// Celebwiki desktop bundle entry — registruje init funkce pro všechny komponenty.
// Každá init nejdřív hledá svůj DOM hook (data-* atribut), a jen pokud existuje,
// dynamicky importuje příslušný chunk (code-splitting per komponenta).
//
// POZOR: Sdílené Blesk DS komponenty (share-toggle, ticker, …) NEinitujeme
// odsud — initují se globálně v `blesk/src/scripts/bundle-2024-redesign.ts`,
// který se nahrává přes `default/blesk/base/js.twig` (design-base) na každé
// celebwiki stránce. Jejich import sem by způsobil dvojitou inicializaci →
// dva click handlery fightují, aria-expanded probliká bez vizuální změny.
// V celebwiki bundle drž jen magazin-specific inity.

const headerInit = async (): Promise<void> => {
	const headerElement = document.querySelector<HTMLElement>('[data-celebwiki-header]');

	if (headerElement === null) return;

	const { header } = await import(
		/* webpackChunkName: 'chunk-celebwiki-header' */
		'./components/header.ts'
	);

	header(headerElement);
};

const nejhledanejsiInit = async (): Promise<void> => {
	const elements = document.querySelectorAll<HTMLElement>('[data-celeb-nejhl]');

	if (elements.length === 0) return;

	const { celebNejhledanejsi } = await import(
		/* webpackChunkName: 'chunk-celebwiki-nejhledanejsi' */
		'./boxes/celebNejhledanejsi.ts'
	);

	for (const el of elements) {
		celebNejhledanejsi(el);
	}
};

const personInit = async (): Promise<void> => {
	const elements = document.querySelectorAll<HTMLElement>('[data-celeb-person]');

	if (elements.length === 0) return;

	const { celebPerson } = await import(
		/* webpackChunkName: 'chunk-celebwiki-person' */
		'./boxes/celebPerson.ts'
	);

	for (const el of elements) {
		celebPerson(el);
	}
};

const peopleFilterInit = async (): Promise<void> => {
	// Opt-in přes Twig param `enableFilter` v `element/celeb-people-grid.twig`.
	const containers = document.querySelectorAll<HTMLElement>('[data-celeb-people-filter]');
	if (containers.length === 0) return;

	const { celebPeopleFilter } = await import(
		/* webpackChunkName: 'chunk-celebwiki-people-filter' */
		'./components/celebPeopleFilter.ts'
	);
	for (const container of containers) {
		celebPeopleFilter(container);
	}
};

const peopleRailInit = async (): Promise<void> => {
	// Rail je opt-in přes Twig param `enablePeopleRail` v `box/celeb-person-body.twig`.
	// Chunk se nepustí, dokud markup `<aside data-celeb-people-rail>` neexistuje.
	const rail = document.querySelector<HTMLElement>('[data-celeb-people-rail]');
	if (rail === null) return;

	const { celebPeopleRail } = await import(
		/* webpackChunkName: 'chunk-celebwiki-people-rail' */
		'./components/celebPeopleRail.ts'
	);
	celebPeopleRail();
};

const relatedToggleInit = async (): Promise<void> => {
	// Sekce „Související celebrity" — tlačítko odkryje skryté profily.
	const containers = document.querySelectorAll<HTMLElement>('[data-celeb-related]');
	if (containers.length === 0) return;

	const { celebRelatedToggle } = await import(
		/* webpackChunkName: 'chunk-celebwiki-related-toggle' */
		'./components/celebRelatedToggle.ts'
	);

	for (const container of containers) {
		celebRelatedToggle(container);
	}
};

const relDiagramInit = async (): Promise<void> => {
	const elements = document.querySelectorAll<HTMLElement>('[data-celeb-rel-diagram]');

	if (elements.length === 0) return;

	const { celebRelDiagram } = await import(
		/* webpackChunkName: 'chunk-celebwiki-rel-diagram' */
		'./components/celebRelDiagram.ts'
	);

	for (const el of elements) {
		celebRelDiagram(el);
	}
};

const init = (): void => {
	void headerInit();
	void nejhledanejsiInit();
	void personInit();
	void relDiagramInit();
	void relatedToggleInit();
	void peopleRailInit();
	void peopleFilterInit();
};

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', init);
} else {
	init();
}
